import { NZ_FLOOD_LAYER } from '../../../../constants/map';

const ZOOM_LEVEL_LIMIT = 14;
const FLOOD_LAYER_COLOR = '#69a1cd';
const FLOOD_LAYER_STYLE = {
    fillOpacity: 0.8,
    fillColor: FLOOD_LAYER_COLOR,
    strokeColor: FLOOD_LAYER_COLOR,
    strokeWeight: 0,
};

const ZOOM_TO_GEO_PRECISION_MAP = {
    // zoomLevel: geometryPrecision
    [ZOOM_LEVEL_LIMIT]: 4,
    15: 5,
    16: 6,
    17: 7,
}

const clearCurrentGeoJson = (mapInstance) => {
    mapInstance?.data?.forEach(layer => {
        const layerId = layer.getId();
        // using the ids generated from getGeoJsonWithFeatureIds()
        if (layerId?.startsWith(NZ_FLOOD_LAYER)) {
            mapInstance.data?.remove(layer);
        }
    });
}

const handleAucklandFloodLayer = (params) => {
    clearCurrentGeoJson(params.mapInstance);
    params.mapInstance?.data?.addGeoJson(params?.geoJson);
    params.mapInstance?.data?.setStyle(FLOOD_LAYER_STYLE);
    params.mapInstance?.data?.addListener('click', params.clickEvent, { once: true });
}

const getGeometryPrecisionByZoomLevel = (zoomLevel = 18) => {
    return ZOOM_TO_GEO_PRECISION_MAP[zoomLevel] || null;
};


// when the geometry precision value is lower, it has a possibility of returning
// duplicate coordinates making the payload too big.
// this function will delete duplicate coordinates to reduce the size
// of the geoJSON we pass in the Google Map component
const removeDuplicateCoords = (currentFeature) => {
    const newFeature = { ...currentFeature };
    const unique = {};
    if (currentFeature.geometry?.coordinates[0]) {
        const removedDuplicates = currentFeature.geometry?.coordinates[0].filter(coord => {
            const stringCoord = `${coord}`;
            if (!unique[stringCoord]) {
                unique[stringCoord] = stringCoord;
                return true;
            }
            return false;
        });
        newFeature.geometry.coordinates[0] = [
            ...removedDuplicates,
            // fixes error: property "features": at index 0: in property "geometry": in property "coordinates": at index 0: first and last positions are not equal
            // see https://stackoverflow.com/a/43237073
            newFeature.geometry.coordinates[0][0],
        ];
    }
    return newFeature;
}

const getGeoJsonWithFeatureIds = (geoJson) => ({
    ...geoJson,
    features: geoJson.features?.map((currentFeature, index) => {
        const newFeature = removeDuplicateCoords(currentFeature);
        newFeature.id =  `${NZ_FLOOD_LAYER}-${index}`;
        return newFeature;
    })
})

const extractPropertyIds = res => (
    res?.features
        ?.map((feature) => feature?.properties?.property_id)
        ?.filter(propertyId => !!propertyId)
);

export default {
    handleAucklandFloodLayer,
    getGeometryPrecisionByZoomLevel,
    getGeoJsonWithFeatureIds,
    ZOOM_LEVEL_LIMIT,
    extractPropertyIds,
}
